module.exports = __webpack_public_path__ + "static/media/cm.94ec67b0.svg";